export type QUERY_DATA = {
    source?: 'online' | 'phantompdf' | 'Teams',
    // Teams
    teamsData?: string;
    teamsDataParsed?: TEAMS_PARSED_DATA;
    // DingTalk
    cropId?: string;
    dingtalkData?: string;
    dingtalkDataParsed?: QUERY_DATA_FROM_DINGTALK;
} & Partial<QUERY_DATA_FROM_TEAMS_LEGACY>;

/** Teams Queries start*/
type QUERY_DATA_FROM_TEAMS_LEGACY = {
    teamsuseremail: string;
    teamsclienttype: string;
    teamsnickname: string
    channelType: string;
    channelName: string;
    contentUrl: string;
    filename: string;
    chatUserId: string;
}

export enum TEAMS_ENTRY_FROM {
    CHANNEL_TAB = 'channelTab',
    TASK_MODULE_FROM_MESSAGE_EXTENSION_CARD = 'taskModuleFromMessageExtensionCard',
    TASK_MODULE_FROM_CHAT = 'taskModuleFromChat',
    TASK_MODULE_FROM_CHANNEL = 'taskModuleFromChannel',
    LEGACY = 'legacy',
}

export type TEAMS_ANNOTS_DATA = {
    name: string;
    parentName?: string;
    pageIndex: number;
}

// EU CA domain, cannot getContext
export type TEAMS_PARSED_DATA = {
    contentUrl?: string;
    fileId?: string;
    driveId?: string;
    isChannel?: boolean;
    entryFrom: TEAMS_ENTRY_FROM;
    nickname: string;
    email: string;
    chatUserId?: string;
    annotData?: TEAMS_ANNOTS_DATA;
}
/** Teams Queries end*/

/** DingTalk Queries start */
export enum DINGTALK_FROM {
    APPLY_NOTIFICATION = 'applyNotification',
}

export type QUERY_DATA_FROM_DINGTALK = {
    from: DINGTALK_FROM;
}
/** DingTalk Queries end */
